//@flow
import {makeStyles} from '@material-ui/core';
import React, {useEffect, useState} from 'react';

import CustomTextField from '../CustomTextField/CustomTextField';
import {colors} from '../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  colorPickerContainer: {
    display: 'flex',
    gap: '.25rem',
    alignItems: 'center',
  },
  colorLabel: {
    width: '48px',
    minWidth: '48px',
    height: '48px',
    borderRadius: '.25rem',
    border: `1.25px solid ${colors.grey300}`,
  },
  inputColor: {
    opacity: 0,
    width: 0,
    height: 0,
    position: 'relative',
  },
  textColorLabel: {
    display: 'flex',
    gap: '.5rem',
    alignItems: 'center',
  },
}));

type Props = {
  value: string,
  onChange: (color: string) => void,
};

export default function ColorInput(props: Props) {
  const {value, onChange} = props;

  const [color, setColor] = useState(value);

  const classes = useStyles();

  useEffect(() => {
    setColor(value);
  }, [value]);

  useEffect(() => {
    onChange(color);
  }, [color, onChange]);

  return (
    <div className={classes.colorPickerContainer}>
      <label className={classes.colorLabel} style={{background: color}}>
        <input
          type="color"
          className={classes.inputColor}
          value={color}
          onInput={e => {
            setColor(e.target.value);
          }}
        />
      </label>

      <CustomTextField
        label=""
        value={color}
        onChange={e => {
          setColor(e.target.value);
        }}
      />
    </div>
  );
}
